var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-checkmark",class:[{ 'is-selected': _vm.selected }, { 'circle-radius': _vm.circleRadius }]},[_c('span',{staticClass:"custom-checkmark__inner",class:{ disabled: _vm.disabled }})])}
var staticRenderFns = []

export { render, staticRenderFns }